import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import SEO from "@/components/site/SEO";

export default function Erstinformation() {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Erstinformation – FINABLE"
        description="Erstinformation der FINABLE GmbH gemäß § 15 VersVermV und § 12 FinVermV: Statusinformation, Beschwerdestellen und Vermittlerregister-Angaben."
        canonical="https://finable.de/erstinformation"
      />
      <Header alwaysSolid />
      <main className="pt-32 pb-20">
        <article className="container max-w-3xl prose prose-slate dark:prose-invert">
          <h1 className="font-display text-4xl md:text-5xl font-bold text-primary">Erstinformation</h1>
          <p className="mt-4 text-lg text-muted-foreground">
            Kundeninformation zur Erfüllung der gesetzlichen Informationspflicht
          </p>

          <h2 className="font-display text-2xl font-bold text-primary mt-10">1. Name, Anschrift und Kontaktdaten</h2>
          <p>
            FINABLE GmbH<br />
            Gärtnerstraße 26a<br />
            20253 Hamburg<br />
            Tel.: 040 5724 9358<br />
            E-Mail: <a href="mailto:moin@finable.de" className="text-accent hover:underline">moin@finable.de</a>
          </p>
          <p><strong>Vertreten durch:</strong><br />Jann Hikko Kromminga</p>

          <h2 className="font-display text-2xl font-bold text-primary mt-10">2. Tätigkeitsart und Beratung</h2>
          <p>
            Die FINABLE GmbH ist als Handelsmakler gemäß § 93 HGB tätig, im Bereich der Versicherungsvermittlung als
            Versicherungsmakler gemäß § 34 d Absatz 1 der Gewerbeordnung und im Bereich der Finanzanlagenvermittlung
            gemäß § 34 f Absatz 1 Satz 1 Nr. 1 (Investmentfonds) der Gewerbeordnung. Die FINABLE ist nicht verpflichtet,
            Verträge für einzelne Produktanbieter zu vermitteln oder für diese zu betreuen, sondern wird im Interesse
            ihrer Kunden tätig. Die Empfehlung und der Rat der FINABLE erfolgen objektiv, ausgewogen und aus einer
            hinreichenden Zahl von auf dem Markt angebotenen Versicherungstarifen und Investmentfonds diverser Anbieter.
            Grundlage für die Entscheidungen sind neben den persönlichen Wünschen und Zielen des Kunden seine weiteren,
            insbesondere im Rahmen der Risikoanalyse gemachten Angaben.
          </p>

          <h2 className="font-display text-2xl font-bold text-primary mt-10">
            3. Unmittelbare oder mittelbare Beteiligungen an den Stimmrechten oder am Kapital
          </h2>
          <p>
            Der Vermittler hält keine solche Beteiligung an einem Versicherungsunternehmen. Ebenso wenig hält ein
            Versicherungsunternehmen eine solche Beteiligung am Vermittler. Auch die FINABLE GmbH hält keine Beteiligung
            an einem Versicherungsunternehmen und auch kein Versicherungsunternehmen eine solche Beteiligung an der FINABLE.
          </p>

          <h2 className="font-display text-2xl font-bold text-primary mt-10">4. Informationen über Art und Quelle der Vergütung</h2>
          <p>Die Vergütung der Tätigkeit erfolgt als:</p>
          <ul>
            <li>konkret vereinbarte Zahlung durch den Kunden oder als</li>
            <li>in der Versicherungsprämie enthaltene Provision, die vom jeweiligen Versicherungsunternehmen ausgezahlt wird oder als</li>
            <li>Kombination aus beidem.</li>
          </ul>
          <p>
            Dies ist jeweils abhängig von den Wünschen und Bedürfnissen des Kunden und den Versicherungs- und
            Finanzprodukten, welche eventuell vermittelt werden.
          </p>

          <h2 className="font-display text-2xl font-bold text-primary mt-10">5. Gemeinsame Registerstelle nach § 11 a Abs. 1 GewO</h2>
          <p>
            Vermittlerregisternummer Versicherungsvermittlung: D-F0L9-4953U-57<br />
            Vermittlerregisternummer Finanzanlagenvermittlung: D-F-131-JECM-13
          </p>
          <p>
            Deutsche Industrie- und Handelskammer<br />
            Breite Straße 29<br />
            10178 Berlin<br />
            <a href="https://www.vermittlerregister.info" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
              https://www.vermittlerregister.info
            </a>
          </p>

          <h2 className="font-display text-2xl font-bold text-primary mt-10">6. Erlaubnisbehörde</h2>
          <p>
            Handelskammer Hamburg<br />
            Adolphsplatz 1<br />
            20457 Hamburg<br />
            <a href="https://www.ihk.de/hamburg" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
              https://www.ihk.de/hamburg
            </a>
          </p>

          <h2 className="font-display text-2xl font-bold text-primary mt-10">7. Schlichtungsstellen</h2>
          <p>
            Schlichtungsstelle für gewerbliche Versicherungs-, Anlage- und Kreditvermittlung<br />
            Barmbeker Straße 2<br />
            22303 Hamburg<br />
            <a href="https://www.schlichtung-finanzberatung.de" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
              https://www.schlichtung-finanzberatung.de
            </a>
          </p>
        </article>
      </main>
      <Footer />
    </div>
  );
}
